export const GAME = {
  width: 6,
  visibleHeight: 14,
  hiddenRows: 2,
  initialGravityMs: 800,
  minGravityMs: 90,
  gravityFactor: 0.82,
  timeGravityFactor: 0.85,
  timeGravityIntervalMs: 30_000,
  lockDelayMs: 450,
  layerSwitchMs: 100,
  spanningChance: 0.2,
  linesPerLevel: 8,
  dasMs: 140,
  arrMs: 45,
} as const;

export const totalHeight = GAME.visibleHeight + GAME.hiddenRows;
